module.exports = __webpack_public_path__ + "static/my-nfts-7a9b62134b44b743cc9d19174961402a.png";